<template>
<div class="chapter">
<div class="inner_page">
<div class="image" id="image3">
<p class="center"><span href="#/035imagecredits#page10" title="Link target outside of Sample"><img alt="" src="images/image-10.jpg"/></span></p>
</div>
<div class="part" id="part1">
<h1><a id="page_11"></a><a href="#/003toc#parti">PART I:<br/>HOW TO HAVE AN ORIGIN<br/>WITHOUT A PLANET BLOWING<br/>UP, PARENTS MURDERED,<br/>RADIOACTIVE SPIDER BITES,<br/>COSMIC RAYS, GAMMA RAYS,<br/>WHITE DWARF STARS, ALIENS<br/>CRASH-LANDING, A MAGIC<br/>WORD, A MAGIC HAMMER,<br/>OR A SUPER SERUM</a></h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006part1.vue?296c4d90